import { render } from "./_preview-attachments.vue?vue&type=template&id=6210d610&scoped=true&lang=pug"
import script from "./_preview-attachments.vue?vue&type=script&setup=true&lang=js"
export * from "./_preview-attachments.vue?vue&type=script&setup=true&lang=js"

import "./_preview-attachments.vue?vue&type=style&index=0&id=6210d610&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6210d610"]])

export default __exports__